import React from 'react';
import { cn } from '../../lib/utils';
interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}
export function Container({
  children,
  className,
  ...props
}: ContainerProps) {
  return <div className={cn('mx-auto max-w-7xl px-4 sm:px-6 lg:px-8', className)} {...props} data-id="element-404">
      {children}
    </div>;
}